import { useNavigate } from "react-router-dom";
import { PAGE_NAME_SELECT_PHENOMENON } from "../../../../constants/common_constants";
import { useDtsAppContext } from "../../../../components/provider/DtsAppContextProvider";
import { useTranslation } from "react-i18next";

interface OccurrenceTimingNextPageButtonProps {
  disabled: boolean;
  occurrenceTiming: number;
}

// ボタン
export const OccurrenceTimingNextPageButton: React.FC<
  OccurrenceTimingNextPageButtonProps
> = ({
  disabled,
  occurrenceTiming,
}) => {
  
  // ページ遷移用
  const navigate = useNavigate();
  //言語切替用
  const { t } = useTranslation();

  const { setDacOccurrenceTiming } = useDtsAppContext();
  
  const handleButtonClick = async () => {

    //Contextに保存+ローカルストレージに保存
    setDacOccurrenceTiming(occurrenceTiming);
    localStorage.setItem("occurrenceTiming", String(occurrenceTiming));

    navigate(`/${PAGE_NAME_SELECT_PHENOMENON}`);
  };

  return (
    <div className="flex justify-center">
      <button
        disabled={disabled}
        className={`${
          !disabled
            ? "border-main-red bg-white"
            : "border-gray-500 bg-gray-300 text-gray-500"
        } rounded-full border-2 py-1 px-6 w-40 overflow-hidden whitespace-nowrap`}
        onClick={handleButtonClick}
      >
        <p className="font-bold text-[20px]">{t("発生タイミング選択画面.次へ")}</p>
        {/* 次へ */}
      </button>
    </div>
  );
};
